import React from 'react'
import { ReviewSerchBox, SearchInputBox } from '../commonSubBanner/commonSubBannerStyle'
import { Button, FormControl, InputGroup } from 'react-bootstrap'

interface Props {
  searchValue:string;
  setSearchValue:React.Dispatch<React.SetStateAction<string>>;
  onSubmit:() => void;
  placeholder:string;
}

const CustomSearch = ({searchValue,setSearchValue,onSubmit, placeholder}:Props) => {
  
  return (
    <ReviewSerchBox>
    <div className="search-header">
     <SearchInputBox className='serch-box'>
      <InputGroup>
        <FormControl type="text" placeholder={placeholder} id="location" name="location" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
      </InputGroup>
      </SearchInputBox>
      <Button variant="outline-success" onClick={() => onSubmit()}>Search</Button>
      </div>
  </ReviewSerchBox>
  )
}

export default CustomSearch
